import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { concat, of, Subject } from 'rxjs';
import {
    catchError, debounceTime,
    distinctUntilChanged, filter, finalize,
    startWith,
    switchMap, takeUntil,
    tap
} from 'rxjs/operators';
import { DEFAULT_EDITOR_TOOLBAR_CONFIG, ToastService } from 'src/app/core';
import { ActiveDirectoryService } from 'src/app/core/active-directory.service';
import {
    Activity,
    ActivityStatus,
    AdUser, CandidateApi,
    CandidateProfile, EmailApi,
    EmailAttachments, EmailMessage,
    PBApi
} from 'src/app/core/api.gen';
import { AttachmentUploadService } from 'src/app/core/attachment-upload.service';
import { AuthService } from 'src/app/core/auth.service';
import { DocumentUploadService } from 'src/app/core/document-upload.service';
import { LoaderService } from 'src/app/core/loader.service';
import { OpenFilePreviewService } from 'src/app/core/open-file-preview.service';
import { nullSafe } from 'src/app/utils';
import { Logger } from 'src/app/utils/Logger';
import { isNullOrUndefined } from '../../../app/core/utils';
import { DocumentService } from '../../core/document.service';
import { LookupFieldKeys } from '../lookup-fields-keys';
import { ModuleTypes } from '../module-types';

@Component({
  selector: 'eos-email',
  templateUrl: './email.component.html'
})

export class EmailComponent implements OnInit {

  candidate_Id: number;
  @Input() public candidate: CandidateProfile;

  onDestroy$ = new Subject<void>();
  tosearchInput$ = new Subject<string>();
  ccsearchInput$ = new Subject<string>();
  toAdUsers: any = [];
  ccAdUsers: any = [];
  toShowLoader;
  ccShowLoader;
  tos = [];
  ccs = [];

  candidateDocs = [];
  selectedCandiFiles = [];
  onSubmit: Function;
  immigrationCaseTypeId: number;

  emailpattern = /^\w+([\.\-\+]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
  fromaddress: string;
  toaddress: string;
  date: string;
  subject: string;
  content: string;
  navLinks: any[];
  activeLinkIndex = -1;
  editorForm: UntypedFormGroup;
  results: EmailMessage;
  activity: Activity;
  isDisabled = false;
  activitytemplateId: number;
  selectedactivitytemplate: any;

  uploadedFiles: EmailAttachments[] = [];
  newAttachments: EmailAttachments[] = [];

  // customAttachments: string[] = [];

  toolbarConfig = { ...DEFAULT_EDITOR_TOOLBAR_CONFIG };

  // upload

  docnamePattern = "^[a-zA-Z0-9 ]*$";
  lookupType: number;
  readonly: boolean;
  country: number;

  @ViewChild('fileField', { static: true }) element: ElementRef;
  @ViewChild('fileControl', { static: true }) fileEle: ElementRef;
  @ViewChild('f', { static: true }) form: NgForm;

  candidateActivityId?: number;
  fileDetails: EmailAttachments;
  selectedDocument: File;
  disableUpload = false;
  moduleType = ModuleTypes.Preboarding;

  showUpload = true;

  readonly allowedMineTypes = [
    'application/pdf'
    , 'image/jpeg'
    , 'image/png'
    , 'application/msword'
    , 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    , 'application/vnd.ms-excel'
    , 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  ];

  readonly MAX_FILE_SIZE: number = 10 * 1024 * 1024;
  readonly MIN_FILE_SIZE: number = 1 * 1024;

  constructor(
    private attachmentUploadService: AttachmentUploadService,
    private documentUploadService: DocumentUploadService,
    private candidateApi: CandidateApi,
    public modal: NgbActiveModal,
    private emailAPI: EmailApi,
    private toast: ToastService,
    private loader: LoaderService,
    private ad: ActiveDirectoryService,
    public authService: AuthService,
    private pbAPI: PBApi,
    private openFilePreviewService: OpenFilePreviewService,
    private emailApi: EmailApi,
    private documentService: DocumentService) {
  }

  ngOnInit(): void {
    this.candidateActivityId = this.activity.id;
    this.candidate_Id = this.candidate.id;
    this.results = new EmailMessage();
    this.fileDetails = new EmailAttachments();
    this.fileDetails.candidateActivityId = this.candidateActivityId;

    this.form.valueChanges.subscribe(x =>
      this.patternValid(this.form)
    );
    this.emailAPI.getActivityEmailMessage(this.candidate_Id, this.activity.id, this.results.activityTemplateId)
      .subscribe((resp) => {
        this.results = resp;
        this.results.activityTemplateId = resp.activityTemplateId;
        this.editorForm.patchValue({ email: this.results.content });
        this.tos = this.addAddresses(resp.toAddresses);
        this.ccs = this.addAddresses(resp.cc);
        this.getUploadedAttachmentDetails(this.candidate_Id, this.activity.id, this.results.activityTemplateId);
        this.getNewlyUploadedAttachmentDetails(this.results.activityTemplateId);
        this.attachCandidateDocToEmail();
        // this.results.customAttachments = this.uploadedFiles;
      });

    this.editorForm = new UntypedFormGroup({
      email: new UntypedFormControl(null)
    });
    this.toAdUsers = this.getAdUsers(true, this.tosearchInput$);
    this.ccAdUsers = this.getAdUsers(false, this.ccsearchInput$);
    this.loadCandidateDocs();
  }



  loadCandidateDocs() {
    this.candidateApi.getCandidateDocsDetails(this.candidate_Id)
      .subscribe(resp => {
        this.candidateDocs = this.documentService.updateCandidateDocs(this.uploadedFiles, true, this.documentService.changeDocumentName(resp, this.moduleType));

      });
  }


  attachCandidateFilesToMail(value) {
    this.selectedCandiFiles = value;
    if (this.selectedCandiFiles.length > 0) {
      this.candidateApi.attachCandidateDocsToMail(this.candidateEmailAttachments())
        .subscribe(resp => {
          this.uploadedFiles.push(...resp);
          this.toast.success("File uploaded successfully!");
          this.candidateDocs = this.documentService.updateCandidateDocs(this.selectedCandiFiles, true, this.candidateDocs);
        }, () => {
          this.toast.error("Something went wrong, couldn't attach files. Please try again later")
        });
    }
  }
  //cr650 start
  saveCandidateDocs(documentList, candidateDocList) {
    candidateDocList.forEach(x => {
      documentList
        .filter(e => e === x.documentId)
        .forEach(e => {
          this.selectedCandiFiles.push(x);
        });
    });
    this.candidateApi.attachCandidateDocsToMail(this.candidateEmailAttachments())
      .subscribe(resp => {
        this.uploadedFiles.push(...resp);
        this.candidateDocs = this.documentService.updateCandidateDocs(this.selectedCandiFiles, true, this.candidateDocs);
      }, () => {
        this.toast.error("Something went wrong, couldn't attach files. Please try again later")
      });
  }

  attachCandidateDocToEmail() {
    let documentList = [];
    //national,localhire,Labour Card or Pension - National
    if (this.activity.id == 2596 || this.activity.id == 2595) {

      if (this.candidate.onboardingType.id == LookupFieldKeys.National && (this.candidate.hireType.id == LookupFieldKeys.Local_Hire || this.candidate.hireType.id == LookupFieldKeys.International_Hire) && this.immigrationCaseTypeId == LookupFieldKeys.LabourCardorPension_National) {
        documentList = [LookupFieldKeys.GPN_JobDescription, LookupFieldKeys.GPN_CV, LookupFieldKeys.GPN_Offer, LookupFieldKeys.GPN_Degree, LookupFieldKeys.GPN_Passport_Emp, LookupFieldKeys.GPN_ProfessionalQualification, LookupFieldKeys.GPN_Academic_Cert];
        this.saveCandidateDocs(documentList, this.candidateDocs);
      }
    }
    //Expat - Local Hires - Visa or Iqama transfer from Company/Family to Company:
    if (this.activity.id == 2815 || this.activity.id == 2596) {
      if (this.candidate.onboardingType.id == LookupFieldKeys.Expat && this.candidate.hireType.id == LookupFieldKeys.Local_Hire && (this.immigrationCaseTypeId == LookupFieldKeys.VisaorIqamatransferfromCompanytoCompany || this.immigrationCaseTypeId == LookupFieldKeys.VisaorIqamatransferfromFamilytoCompany)) {
        documentList = [LookupFieldKeys.GPN_JobDescription, LookupFieldKeys.GPN_Offer, LookupFieldKeys.GPN_Passport_Emp, LookupFieldKeys.GPN_ProfessionalQualification, LookupFieldKeys.GPN_CV, LookupFieldKeys.GPN_ProfessionalMembership, LookupFieldKeys.GPN_Degree, LookupFieldKeys.GPN_Academic_Cert, LookupFieldKeys.GPN_National_ID, LookupFieldKeys.GPN_VisaPreApproval];
        this.saveCandidateDocs(documentList, this.candidateDocs);
      }
      //Expat-International hire - Employment visa application-outside country
      else if (this.candidate.onboardingType.id == LookupFieldKeys.Expat && this.candidate.hireType.id == LookupFieldKeys.International_Hire && this.immigrationCaseTypeId == LookupFieldKeys.Employmentvisaapplication_outsidecountry) {
        documentList = [LookupFieldKeys.GPN_JobDescription, LookupFieldKeys.GPN_Offer, LookupFieldKeys.GPN_Passport_Emp, LookupFieldKeys.GPN_CV, LookupFieldKeys.GPN_Degree, LookupFieldKeys.GPN_ProfessionalQualification, LookupFieldKeys.GPN_Academic_Cert, LookupFieldKeys.GPN_VisaPreApproval];
        this.saveCandidateDocs(documentList, this.candidateDocs);
      }
    }
    if (this.activity.id == 2815 || this.activity.id == 2596 || this.activity.id == 2595) {
      if (documentList != null && documentList.length == 0)
        this.toast.warning('Document auto attached failed, due to mismatch in Hire type, Pre-boarding type and Immigration type. Kindly attach manually')
    }
  }
  //cr650 end

  candidateEmailAttachments() {
    let files = [];
    this.selectedCandiFiles.forEach(item => {
      const attachment = new EmailAttachments({
        fileName: item.fileName,
        fileGuiId: item.fileGuiId,
        candidateActivityId: this.activity.candidateActivityId,
        emailTemplateId: this.results.activityTemplateId
      })
      files.push(attachment)
    });
    return files;
  }

  adUser() {
    return new AdUser({
      displayName: `${this.candidate.firstName} ${this.candidate.lastName}`,
      userPrincipalName: this.candidate.emailID,
    });
  }

  patternValid(f: NgForm) {
    const ccForm = f.form.get("cc");
    const addressForm = f.form.get("toAddresses");

    if (!isNullOrUndefined(addressForm)) {
      addressForm.value.forEach(item => {
        if (!item.match(this.emailpattern) && !isNullOrUndefined(addressForm)) {
          addressForm.setErrors({ incorrect: true });
        }
      });
    }

    if (!isNullOrUndefined(ccForm)) {
      if (ccForm.value.length === 0) {
        ccForm.setErrors(null);
        return;
      }
      ccForm.value.forEach(item => {
        const valid = item.match(this.emailpattern);
        if (!item.match(this.emailpattern) && !isNullOrUndefined(ccForm)) {
          ccForm.setErrors({ incorrect: true });
        }
      });
    }
  }

  addAddresses(email: string) {
    const emailArray = [];
    if (email && email.length > 0) {
      email.split(';').forEach(item => {
        // if (item.match(this.emailpattern)) {
        if (item != "") {
          emailArray.push(item);
        }
        // }
      });
    }

    return emailArray;
  }

  getAdUsers(setToLoader: boolean, subject) {
    let obs = concat(
      of([]),
      subject.pipe(
        takeUntil(this.onDestroy$),
        startWith(''),
        filter((v: string) => v !== null && v.length > 2),
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => {
          this.setAdloader(setToLoader);
        }),
        switchMap((term: string) => this.ad.getAdUsers(term).pipe(
          catchError(() => of([])),
          tap((users) => {
            this.toShowLoader = false;
            this.ccShowLoader = false;
            if (nullSafe<boolean>(() => this.candidate.firstName.toLowerCase().startsWith(term.toLowerCase()), false)
              || nullSafe<boolean>(() => this.candidate.emailID.toLowerCase().startsWith(term.toLowerCase()), false)) {
              users.push(this.adUser());
            }
          })
        ))
      ));
    return obs;
  }

  setAdloader(isToLoader) {
    if (isToLoader) {
      this.toShowLoader = true;
      this.ccShowLoader = false;
    } else {
      this.toShowLoader = false;
      this.ccShowLoader = true;
    }
  }


  getUploadedAttachmentDetails(profileId: number, activityId: number, emailTemplateId: number) {
    this.candidateApi.getAttachmentsDetails(profileId, activityId, emailTemplateId).subscribe(resp => {
      this.uploadedFiles = resp;
      this.loadCandidateDocs();
      // this.results.customAttachments = this.uploadedFiles;
      // this.results.customAttachments = resp;
      // console.log(this.uploadedFiles);
    });
  }
  getNewlyUploadedAttachmentDetails(emailTemplateId: number) {
    this.emailApi.getAttachmentsNewDetails(emailTemplateId).subscribe(resp => {
      this.newAttachments = resp;
    });
  }



  delete(fileDetails) {
    this.candidateApi.deleteAttachment(fileDetails).subscribe((resp) => {
      this.toast.success("Attachment deleted!");
      this.selectedCandiFiles = [];
      this.selectedCandiFiles.push(fileDetails);
      this.getUploadedAttachmentDetails(this.candidate_Id, this.activity.id, this.results.activityTemplateId);
      this.candidateDocs = this.documentService.updateCandidateDocs(this.uploadedFiles, false, this.candidateDocs);
    });
  }

  downloadAttachment(details) {
    this.attachmentUploadService.downloadAttachment(details);
  }

  downloadAll(id: number) {
    const typeId = -1;

    if (this.uploadedFiles.length <= 0) {
      this.toast.warning("No files to download!");
      return;
    }

    this.attachmentUploadService.downloadAttachmentsAll(id, typeId).subscribe(resp => {

      if ((window.navigator as any).msSaveOrOpenBlob) {
        (window.navigator as any).msSaveBlob(resp, "Documents.zip");
      } else {
        const url = window.URL.createObjectURL(resp);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.setAttribute("style", "display: none");
        a.href = url;
        a.download = "Documents.zip";
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      }
    });
  }

  GetDocuments($event) {
    this.uploadedFiles = $event;
    // this.results.customAttachments = this.uploadedFiles;
    // this.results.customAttachments = $event;
  }

  sendMail(f: NgForm) {

    if (f.invalid) {
      return;
    }
    this.results.toAddresses = this.tos.join(';');
    this.results.cc = this.ccs.join(';');
    this.results.candidateActivityId = this.activity.candidateActivityId;
    this.results.customAttachments = [...this.uploadedFiles, ...this.newAttachments];

    this.isDisabled = true;
    this.loader.show();
    this.emailAPI.sendMail(this.candidate_Id, this.results).pipe(finalize(() => {
      this.isDisabled = false;
    }))
      .subscribe((resp) => {
        this.updateActivity().pipe(finalize(() => {
          this.loader.clear();
        })).subscribe((res) => {
          this.toast.success("Activity completed");
          this.onSubmit(res.completedDate, res.modifiedByNm);
          this.modal.close();
        });
      }, (err) => {
        this.toast.error('Error occured while sending email.');
        this.loader.clear();
        Logger.error(err);
      });
  }

  TemplateLoad(e) {
    this.uploadedFiles = null;
    this.activitytemplateId = e.target.value;
    this.emailAPI.getActivityEmailMessage(this.candidate_Id, this.activity.id, this.results.activityTemplateId)
      .subscribe((resp) => {
        this.results = resp;
        this.results.activityTemplateId = resp.activityTemplateId;
        this.tos = this.addAddresses(resp.toAddresses);
        this.ccs = this.addAddresses(resp.cc);
        this.editorForm.patchValue({ email: this.results.content });
        this.getUploadedAttachmentDetails(this.candidate_Id, this.activity.id, this.results.activityTemplateId);
        this.getNewlyUploadedAttachmentDetails(this.results.activityTemplateId);
      });

  }

  removeAttachment(id) {
    if (this.newAttachments.includes(id))
      this.newAttachments.splice(this.newAttachments.indexOf(id), 1);
    else {
      this.results.attachments.splice(id, 1);
    }
  }

  updateActivity() {
    return this.pbAPI.updateCandidateActivity(this.candidate_Id, this.activity.id, ActivityStatus.Done);
  }

  // Upload Controls

  get ifDocNotValid(): boolean {
    if (this.selectedDocument && (this.selectedDocument.size < this.MIN_FILE_SIZE || this.selectedDocument.size > this.MAX_FILE_SIZE)) {
      return true;
    }

    return false;
  }

  browseFile() {
    // console.log(this.fileEle);
    this.fileEle.nativeElement.click();
  }

  get fileBrowserAllowedTypes() {
    return this.allowedMineTypes.join(',');
  }

  fileSelected(files: FileList) {
    // console.log(files);
    if (!files.item(0)) {
      return;
    }
    this.selectedDocument = files.item(0);

    if (this.selectedDocument.size < this.MIN_FILE_SIZE || this.selectedDocument.size > this.MAX_FILE_SIZE) {

      this.toast.error(`Invalid file size. File size should be between ${(this.MIN_FILE_SIZE / 1024).toFixed()} KB
       and ${(this.MAX_FILE_SIZE / 1024 / 1024).toFixed()} MB`);

      this.fileEle.nativeElement.value = null;
      return;
    }
    if (this.allowedMineTypes.indexOf(this.selectedDocument.type) < 0) {
      this.toast.error(`Invalid file type. Please select a valid file`);
      this.fileEle.nativeElement.value = null;
      this.selectedDocument = null;
      this.element.nativeElement.value = "";
      return;
    }

    this.fileDetails.fileName = this.selectedDocument.name;
  }

  get selectedFileName(): string {
    return nullSafe(() => this.selectedDocument.name, '');
  }


  uploadDoc(f: NgForm) {

    // console.log(this.uploadedFiles);
    // this.getUploadedAttachmentDetails(this.candidateActivityId);

    if (f.invalid) {
      return;
    }

    if (this.ifDocNotValid) {
      this.toast.error(`Invalid file size. File size should be between ${(this.MIN_FILE_SIZE / 1024).toFixed()}
       KB and ${(this.MAX_FILE_SIZE / 1024 / 1024).toFixed()} MB`);
      return;
    }
    if (isNullOrUndefined(this.selectedDocument)) {
      this.toast.warning("Please select a file!");
      return;
    }
    // if (this.allFiles.some((item) => (item.fileName === this.fileDetails.fileName) && (item.id !== this.fileDetails.id))) {
    if (this.uploadedFiles.some((item) => (item.fileName === this.selectedDocument.name) && (item.id !== this.fileDetails.id))) {
      this.toast.error("Attachment Name should be unique");
      return;
    }

    this.fileDetails.id = -1;
    this.fileDetails.candidateActivityId = this.candidateActivityId;
    this.fileDetails.emailTemplateId = this.results.activityTemplateId;
    this.fileDetails.createdById = this.authService.ActiveUser.employeeId;
    this.fileDetails.modifiedById = this.authService.ActiveUser.employeeId;
    this.fileDetails.candidateId = this.candidate_Id;
    this.fileDetails.activityId = this.activity.id;

    this.upload(f);

    // this.getUploadedAttachmentDetails(this.candidateActivityId);
  }

  upload(f: NgForm) {
    f.form.disable();
    this.disableUpload = true;
    this.isDisabled = true;
    this.attachmentUploadService.postFile(this.fileDetails, this.selectedDocument).pipe(finalize(() => {
      this.selectedDocument = null;
      this.fileEle.nativeElement.value = null;
      f.form.enable();
      this.disableUpload = false;
      this.isDisabled = false;
      // f.reset({});
    }))
      .subscribe(resp => {
        // this.updateAllFiles(resp.data);
        this.element.nativeElement.value = "";
        if (this.selectedDocument) {
          this.toast.success("File uploaded successfully!");
        } else {
          this.toast.success("Document details updated successfully!");
        }
        this.getUploadedAttachmentDetails(this.candidate_Id, this.activity.id, this.results.activityTemplateId);
      }, error => {
        this.toast.error("Something went wrong!");
      });
    // this.GetDocumentEvent.emit(this.uploadedFiles);
  }

  downloadFile(fileName: string) {
    this.documentUploadService.downloadDocumentFile(fileName);
  }

  previewFile(fileName: string) {
    this.openFilePreviewService.previewAttachmentFile(fileName);
  }

  saveMailAsDraft(f: NgForm) {

    f.form.disable();
    this.results.candidateId = this.candidate_Id;
    this.results.candidateActivityId = this.activity.candidateActivityId;
    this.results.toAddresses = this.tos.join(";");
    this.results.cc = this.ccs.join(";");

    this.loader.show();
    this.emailAPI.saveAsDraft(this.results).pipe(finalize(() => {
      this.loader.clear();
      f.form.enable();
    })).subscribe(resp => {
      this.results.emailHistoryId = resp.data;
      this.toast.success("Mail saved as draft!");
    });
  }

}

